import styled from "styled-components";

export const Container = styled.div`
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;